<template>
  <v-row>
    <v-col cols="12">
      <v-card flat>
        <v-card-text class="pa-0">
          <v-row>
            <!-- display -->
            <v-col cols="8" :key="playerActionsKey">
              <table border="0" cellpadding="0" bordercollapse="1" width="100%">

                <tr v-if="isOurClubPartnerBot">
                  <td colspan="100" style="color: lightblue">Our Club!</td>
                </tr>

                <tr v-if="isTournament">
                  <td colspan="100" style="color: orange" class="text-h6 text-decoration-underline"><strong>Tournament</strong></td>
                </tr>

                <tr v-if="activeChatAccount.contacting_host_not_available">
                  <td colspan="100">
                    <span class="red--text text-h5 font-weight-bold" style="text-shadow: 0 0 10px #f00">
                      If host asks contact again, make excuse to text them later
                    </span>
                  </td>
                </tr>

                <tr v-if="hasGivenWarning()">
                  <td colspan="4">
                    Gave warning at #{{ warningHand() }}<template v-if="as && !as.want_to_stand">, but we don't want to leave anymore, no action needed</template>
                  </td>
                </tr>
                <tr>
                  <td colspan="100" v-if="activeChatAccount.warned_again">
                    Warned again at #{{ activeChatAccount.warned_again.hand_num }}<template v-if="as && !as.want_to_stand">, but we don't want to leave anymore, no action needed</template>
                  </td>
                </tr>

                <tr v-if="onlyRequiredChats" style="color: orange">
                  Limited Chat Account! Only chat if name mentioned or giving warning/asking calltime.
                </tr>

                <tr v-if="state && state.room && state.room.status === 'PAUSE'" style="color: #54bfe3">
                  <td colspan="100">
                    Room is paused
                      <template v-if="!(as && as.stand_now || as && as.give_warning_now)">
                        - wait until game resumes or system tells you to leave
                      </template>
                  </td>
                </tr>
                <tr v-if="state && state.room && state.room.status === 'WAITING'" style="color: #54bfe3">
                  <td colspan="100">
                    Room is waiting
                      <template v-if="!(as && as.stand_now || as && as.give_warning_now)">
                        - wait until reload, game resumes or system tells you to leave
                      </template>
                  </td>
                </tr>
                <tr v-if="state && state.room && state.room.status === 'PREPARE'" style="color: yellow">
                  <td colspan="100">
                    Room is preparing
                      <template v-if="!(as && as.stand_now || as && as.give_warning_now)">
                        - wait until game starts or system tells you to leave
                      </template>
                  </td>
                </tr>

                <template v-if="as">
                  <tr v-if="as.stand_now" class="warn-stand-now">
                    <td colspan="100"><b>Stand up now!</b><br>
                      <template v-if="as.want_to_stand">Why want to stand? {{ as.want_to_stand_reason}}</template><br>
                      Why stand now? {{ as.stand_now_reason }}<br>
                      <template v-if="as.no_rewarn_reason">Why no re-warn? {{ as.no_rewarn_reason }}</template>
                    </td>
                  </tr>

                  <tr v-else-if="as.give_warning_now" class="warn-warn-now">
                    <td colspan="100">
                      <b>Give warning now!</b><br>
                      <template v-if="as.want_to_stand">Why want to stand? {{ as.want_to_stand_reason}}</template><br>
                      Why warn? {{ as.give_warning_reason }}
                    </td>
                  </tr>

                  <tr v-else-if="as.want_to_stand">
                    <td colspan="100">
                      Waiting to stand: {{ as.want_to_stand_reason }}<br>
                      Why waiting? {{ as.stand_now_reason }}
                    </td>
                  </tr>
                </template>

                <tr v-if="isCalltimeClubWithWindow">
                  <td colspan="100" style="color: orange">Calltime Club w/ Window</td>
                </tr>
                <tr v-if="isCalltimeClubWithoutWindow">
                  <td colspan="100" style="color: orange">Calltime Club without Window</td>
                </tr>

                <tr v-if="club && club.min_hands_rule && club.min_hands_rule !== 'GC'">
                  <td colspan="100">{{ club.min_hands_rule }} hands minimum to play before leaving</td>
                </tr>

                <template v-if="isCalltimeClubWithWindow">
                  <tr colspan="100">
                    <td><b>If call-time is needed</b>, explicitly send '{{ calltimeText }}' message to get the call-time window.</td>
                  </tr>
                  <tr colspan="100" v-if="club && club.initial_warning_rule">
                    <td>You must then input the call-time window on the give warning dialog.</td>
                  </tr>
                  <tr colspan="100">
                    <td>If you miss the window, you have to send '{{ calltimeText }}' again and get a new window.</td>
                  </tr>
                  <tr colspan="100">
                    <td>No additional warning or message is required to leave once in the window.</td>
                  </tr>
                </template>

                <template v-if="isCalltimeClubWithoutWindow">
                  <tr colspan="100">
                    <td><b>If call-time is needed</b>, explicitly send '{{ calltimeText }}' message to announce call-time.</td>
                  </tr>
                  <tr colspan="100">
                    <td>There is no call-time window: you can leave enough hands or time elapses.</td>
                  </tr>
                  <tr colspan="100">
                    <td>No additional warning or message is required to leave once the calltime is up.</td>
                  </tr>
                </template>

                <template v-else>
                  <tr v-if="club">
                    <td colspan="100">
                      <template v-if="club.initial_warning_rule && club.initial_warning_rule.type !== 'never' &&
                                      club.warn_suggestion_type === 'explicit_last_hand_num'">
                        <div style="color: orange">Write last hand # when warning (e.g. "#115")</div>
                      </template>
                      <template v-if="!(club.initial_warning_rule && club.initial_warning_rule.type)">
                        General courtesy - follow instructions for warning & leaving
                      </template>
                      <template v-else-if="club.initial_warning_rule.type === 'general_courtesy'">
                        General courtesy - follow instructions for warning & leaving
                      </template>
                      <template v-else-if="club.initial_warning_rule.type === 'never'">
                        Warning before leaving: Never needed
                      </template>
                      <template v-else>
                        Warning before leaving:
                        <template v-if="club.initial_warning_rule.warning_quantity_type === 'minutes'">
                          {{ club.initial_warning_rule.num_minutes }} minutes
                        </template>
                        <template v-else>
                          {{ club.initial_warning_rule.num_hands }} hands
                        </template>
                        / {{ ruleName(club.initial_warning_rule) }}
                        <template v-if="club.re_warning_rule">
                          <br>Need to warn again when leaving: {{ ruleName(club.re_warning_rule) }}
                        </template>
                      </template>
                    </td>
                  </tr>
                </template>

                <!-- debug stuff -->
                <template v-if="isDev">
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" style="display: inline">
                        <v-icon>mdi-account-box-outline</v-icon>
                      </v-btn>
                    </template>
                    <pre>{{ activeChatAccount }}</pre>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on }">
                      <v-btn icon v-on="on" style="display: inline" @click="openDebugAs">
                        <v-icon>mdi-bug</v-icon>
                      </v-btn>
                    </template>
                    <pre>{{ as }}</pre>
                  </v-tooltip>
                </template>
              </table>
            </v-col>
            <!-- menu -->
            <v-col cols="4" class="d-flex flex-column justify-center">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs}">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on" block :disabled="isDisconnected">Actions</v-btn>
                </template>
                <v-list>
                  <v-list-item @click="updateSnoozed">
                    <v-list-item-title v-if="activeChatAccount.snoozed">Un-snooze</v-list-item-title>
                    <v-list-item-title v-else>Snooze</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="updatePriming">
                    <v-list-item-title v-if="activeChatAccount.priming">Done priming</v-list-item-title>
                    <v-list-item-title v-else>Priming</v-list-item-title>
                  </v-list-item>
                  <!-- only claimed person can unclaim it -->
                  <v-list-item @click="updateClaimed" v-if="activeChatAccount.claimed && activeChatAccount.claimed_user_id === activeOperatorId">
                    <v-list-item-title>Unclaim</v-list-item-title>
                  </v-list-item>
                  <!-- if it's not claimed then you can claim it -->
                  <v-list-item @click="updateClaimed" v-else-if="!activeChatAccount.claimed">
                    <v-list-item-title >Claim Account</v-list-item-title>
                  </v-list-item>
                  <v-divider></v-divider>

                  <template v-if="!activeChatAccount.operator_dont_want_to_leave">
                    <v-list-item @click="askRemoveWantToLeave=true;openDialog()" v-if="activeChatAccount.operator_want_to_leave">
                      <v-list-item-title style="color: #14d0f1">Remove Want to Leave</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="askWantToLeave=true;openDialog()" v-else>
                      <v-list-item-title>Want to Leave</v-list-item-title>
                    </v-list-item>
                  </template>

                  <template v-if="!activeChatAccount.operator_want_to_leave">
                    <v-list-item @click="askRemoveDontWantToLeave=true;openDialog()" v-if="activeChatAccount.operator_dont_want_to_leave">
                      <v-list-item-title style="color: #14d0f1">Remove Don't Leave</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="askDontWantToLeave=true;openDialog()" v-else>
                      <v-list-item-title style="color: #FF8C00"><strong>Don't Leave</strong></v-list-item-title>
                    </v-list-item>
                  </template>

                  <template v-if="isCalltimeClubWithWindow">
                    <v-list-item v-if="!hasGivenWarning()" @click="askWarning=true; openDialog()">
                      <v-list-item-title>Gave Warning (Calltime)</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="hasGivenWarning()" @click="askRemoveWarning=true; openDialog()">
                      <v-list-item-title style="color: #14d0f1">Remove Gave Warning</v-list-item-title>
                    </v-list-item>
                    <!-- for ct club, put the warning on the same warning slot -->
                    <v-list-item v-if="hasGivenWarning()" @click="askWarning=true; openDialog()">
                      <v-list-item-title>Warned Again (Calltime)</v-list-item-title>
                    </v-list-item>
                  </template>
                  <template v-else>
                    <v-list-item v-if="!hasGivenWarning()" @click="askWarning=true; openDialog()">
                      <v-list-item-title>Gave Warning</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="hasGivenWarning()" @click="askRemoveWarning=true; openDialog()">
                      <v-list-item-title style="color: #14d0f1">Remove Gave Warning</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="hasGivenWarning()" @click="askWarnAgain=true; openDialog()">
                      <v-list-item-title>Warned Again</v-list-item-title>
                    </v-list-item>


                    <!-- change minutes/hands actions -->
                    <template v-if="hasGivenWarning() && club && club.initial_warning_rule && ![undefined, null, 'never'].includes(club.initial_warning_rule.type)">
                      <v-list-item v-if="club.initial_warning_rule.warning_quantity_type === 'minutes'" @click="askChangeWarningQuantity=true; openDialog()">
                        <v-list-item-title>Change Warning Minutes</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-else-if="club.initial_warning_rule.warning_quantity_type === 'hands'" @click="askChangeWarningQuantity=true; openDialog()">
                        <v-list-item-title>Change Warning Hands</v-list-item-title>
                      </v-list-item>
                    </template>
                  </template>

                  <v-divider></v-divider>

                  <v-list-item @click="askReload=true">
                    <v-list-item-title>Reload Chips</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="askAddBonus=true">
                    <v-list-item-title>Reload Chips (Bonus)</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="askTakeBreak=true;openDialog()">
                    <v-list-item-title v-if="activeChatAccount.break">On Break</v-list-item-title>
                    <v-list-item-title v-else>Take a Break</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="weAreObserving" @click="askSit=true; openDialog();">
                    <v-list-item-title style="color: #37dc37">Sit</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="observe30mins()">
                    <v-list-item-title style="color: yellow">Observe for 30m</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="ourPlayer && !ourPlayer.sitout" @click="askSitOut=true; openDialog()">
                    <v-list-item-title>Sit out</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="ourPlayer && ourPlayer.sitout" @click="sitback">
                    <v-list-item-title>Sit back</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="askGetUpSafely=true; openDialog();">
                    <v-list-item-title>Get up Safely</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="askTimeOutOnce=true; openDialog();">
                    <v-list-item-title style="color: #FF8C00">Time Out Once</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="askTimeOutHand=true; openDialog();">
                    <v-list-item-title style="color: #FF8C00">Time Out Hand</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="askGetUpOnly=true; openDialog();">
                    <v-list-item-title style="color: #ec3333">Get up End of Hand</v-list-item-title>
                  </v-list-item>

                  <v-list-item @click="askLeaveOnly=true; openDialog();">
                    <v-list-item-title style="color: #ec3333">Leave immediately</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="askRestart=true; safeRestart=false;">
                    <v-list-item-title style="color: #ec3333">Restart (Hard)</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="askRestart=true; safeRestart=true;">
                    <v-list-item-title style="color: #ec3333">Restart (Safely)</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="askLogout=true">
                    <v-list-item-title style="color: #ec3333">Shutdown</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn color="primary" class="mt-2" @click="openTable" block>
                <span class="mr-2">Watch Table</span>
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>

              <!-- BUYIN REJECTED RESOLVED -->
              <v-btn color="green darken-2"
                 class="mt-2"
                 @click="openResolveRejectedBuyin()"
                 block
                 v-if="canResolveRejectedBuyin"
              >
                <span class="mr-2">Buy-in Reject Resolved</span>
                <v-icon>mdi-currency-usd</v-icon>
              </v-btn>

              <!-- CONTACT HOST AND CONTACT HOST RESOLVED -->
              <v-btn color="green" class="mt-2" @click="openReport(true)" block
                     v-if="!activeChatAccount.contacting_host && !activeChatAccount.contacting_host_not_available" :disabled="isDisconnected">
                <span class="mr-2">Contact Host</span>
                <v-icon>mdi-message</v-icon>
              </v-btn>
              <v-btn color="green darken-2"
                class="mt-2"
                @click="openReport(true, true)"
                block v-else
                :disabled="isResolvedDisabled"
              >
                <span class="mr-2">Contact Resolved</span>
                <v-icon>mdi-message</v-icon>
              </v-btn>

              <v-btn color="red" class="mt-2" @click="openReport(false)" block>
                <span class="mr-2">Report Incident</span>
                <v-icon>mdi-alert-circle</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <!-- spacer ? -->
          <v-row>
            <v-col cols="12">

            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialogs -->
    <div class="text-center">

      <v-dialog v-model="showDebugAs" width="1200">
        <v-card>
          <v-card-title>Automation State - {{ activeChatAccountName }}</v-card-title>
          <v-card-text>
            <pre>{{ as }}</pre>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askLeaveOnly" width="500">
        <v-card>
          <v-card-title>Confirm Leave with {{ activeChatAccountName }}?</v-card-title>
          <v-card-text v-if="!systemAskingToStand" style="color: #ec3333">
            The system is not asking {{ activeChatAccountName }} to stand now!
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="leaveOnly">Leave</v-btn>
            <v-btn text @click="askLeaveOnly=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askTimeOutOnce" width="500">
        <v-card>
          <v-card-title><span>Confirm time out <strong>ONCE</strong> for {{ activeChatAccountName }}?</span></v-card-title>
          <v-card-text class="d-flex flex-column justify-center">
            <span class="text-center orange--text">WARNING: This will make {{ activeChatAccountName }} time out once.</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" text @click="timeOutOnce">Time Out</v-btn>
            <v-btn text @click="askTimeOutOnce=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askTimeOutHand" width="500">
        <v-card>
          <v-card-title><span>Confirm time out <strong>HAND</strong> for {{ activeChatAccountName }}?</span></v-card-title>
          <v-card-text class="d-flex flex-column justify-center">
            <span class="text-center orange--text">WARNING: This will make {{ activeChatAccountName }} time out the entire hand.</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" text @click="timeOutHand">Time Out</v-btn>
            <v-btn text @click="askTimeOutHand=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askGetUpOnly" width="500">
        <v-card>
          <v-card-title>Confirm Get Up with {{ activeChatAccountName }}?</v-card-title>
          <v-card-text class="d-flex flex-column justify-center">
            <span v-if="!systemAskingToStand" style="color: #ec3333" class="text-center mb-3">
              The system is not asking {{ activeChatAccountName }} to stand now!
            </span>

            <span class="text-center orange--text">WARNING: This might leave after winning a large pot! Take care if club has warning rules.</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="getUp">Get Up</v-btn>
            <v-btn text @click="askGetUpOnly=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askGetUpSafely" width="500">
        <v-card>
          <v-card-title>Confirm Get Up Safely with {{ activeChatAccountName }}?</v-card-title>
          <v-card-text>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="orange" text @click="getUpSafely">Get Up Safely</v-btn>
            <v-btn text @click="askGetUpSafely=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askLeave" width="500">
        <v-card>
          <v-card-title>Confirm Leave with {{ activeChatAccountName }}?</v-card-title>
          <v-card-text v-if="!systemAskingToStand" style="color: #ec3333">
            The system is not asking {{ activeChatAccountName }} to stand now!
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="leave">Leave</v-btn>
            <v-btn text @click="askLeave=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- warning change amount -->
      <v-dialog v-model="askChangeWarningQuantity" width="500">
        <v-card>
          <v-card-title>Change Warning ({{ getChangeWarningQuantityType() }})?</v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-col cols="6">
                <v-text-field
                  label="Current Value" class="centered-input"
                  :value="getWarningQuantityValue()"
                  readonly disabled hide-details outlined dense
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  type="number" label="New Value" class="centered-input"
                  outlined hide-details dense
                  v-model.number="warningQuantityInput">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="!warningQuantityInput || warningQuantityInput <= 0">
              <v-col cols="12" style="color: orange">
                Input new value
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!warningQuantityInput || warningQuantityInput <= 0"
              color="primary" text @click="changeWarningQuantity">Change</v-btn>
            <v-btn
              text @click="askChangeWarningQuantity=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <!-- warning -- calltime -->
      <v-dialog v-model="askWarning" width="500" v-if="isCalltimeClubWithWindow">
        <v-card>
          <v-card-title>Confirm Got Calltime Window?</v-card-title>
          <v-card-text>
            <v-row align="center">
              <v-col cols="12">
                Input the calltime window that the table host told you when you sent '{{ calltimeText }}'.
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12">
                If they only posted one number instead of a window, then assume the window size is 5.
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="4">
                <v-text-field
                  outlined hide-details dense
                  type="number" label="Window Start" class="centered-input" v-model="ctWindowInput.start"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  outlined hide-details dense
                  type="number" label="Window Size" class="centered-input" v-model="ctWindowInput.size"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                  outlined hide-details dense
                  type="number" label="Window End" class="centered-input" v-model="ctWindowInput.end" readonly disabled>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" style="color: orange">
                <template v-if="!ctWindowInput.start">Input start window</template>
                <template v-else-if="!ctWindowInput.end">Input end window</template>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="onGaveWarning" :disabled="!ctWindowInput.start || !ctWindowInput.end">
              Confirm
            </v-btn>
            <v-btn text @click="askWarning=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- warning -- regular -->
      <v-dialog v-model="askWarning" width="500" v-else>
        <v-card>
          <v-card-title>Confirm {{ activeChatAccountName }} Gave Warning to Leave?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="onGaveWarning">Confirm</v-btn>
            <v-btn text @click="askWarning=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askRemoveWarning" width="500">
        <v-card>
          <v-card-title>Remove Gave Warning to Leave?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="onRemoveGaveWarning">Confirm</v-btn>
            <v-btn text @click="askRemoveWarning=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askWarnAgain" width="500">
        <v-card>
          <v-card-title>Confirm {{ activeChatAccountName }} Warned to Leave Again?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="onWarnedAgain">Confirm</v-btn>
            <v-btn text @click="askWarnAgain=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askSitOut" width="500">
        <v-card>
          <v-card-title>Confirm Sit Out with {{ activeChatAccountName }}?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="sitout">Sit Out</v-btn>
            <v-btn text @click="askSitOut=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askSit" width="500">
        <v-card>
          <v-card-title>Confirm Sit with {{ activeChatAccountName }}?</v-card-title>
          <v-card-text>
            <v-text-field label="Chips" outlined hide-details v-model="sitChips" type="number"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="color: #37dc37" text @click="onSit">Sit</v-btn>
            <v-btn text @click="askSit=false; sitChips=0">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askReload" width="600">
        <v-card>
          <v-card-title>Confirm Reload with {{ activeChatAccountName }}?</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                This will submit a reload of 100 BBs, limited by the minimum and maximum buy-in.
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="6">
                Available Bankroll: <strong>${{ balance }}</strong><br/>
                Blinds: <strong>${{ bb() }}</strong><br/>
                <template v-if="state && state.settings">
                  Buy in range: <strong>${{ state.settings.buyInRangeBBMin * bb() }} - ${{ state.settings.buyInRangeBBMax * bb() }}</strong>
                </template>
              </v-col>
              <v-col cols="3" >
                <v-btn color="red" text @click="reload">Reload ${{ 100 * bb() }}</v-btn>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="3" offset="3">
                <v-text-field label="custom amount" dense width="30px" class="centered-input" v-model="chips"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-btn text color="red" @click="reloadCustom(false)">Reload Custom Amount</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="askReload=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askAddBonus" width="600">
        <v-card>
          <v-card-title>Reload as Bonus with {{ activeChatAccountName }}?</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-text-field label="Amount (CHM)" outlined hide-details v-model="chips" type="number"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-textarea label="Bonus Reason" outlined hide-details v-model="bonusReason"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="green" @click="reloadCustom(true)" :disabled="bonusReason.length < 3 || chips === 0">Add Bonus</v-btn>
            <v-btn text @click="askAddBonus=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askRestart" width="500">
        <v-card>
          <v-card-title>Confirm Restart {{ activeChatAccountName }}?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="restart">Restart</v-btn>
            <v-btn text @click="askRestart=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askLogout" width="500">
        <v-card>
          <v-card-title>Confirm Shutdown {{ activeChatAccountName }}?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click="logout">Shutdown</v-btn>
            <v-btn text @click="askLogout=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askTakeBreak" width="600">
        <v-card>
          <v-card-title>Take a break with {{ activeChatAccountName }}?</v-card-title>
          <v-card-actions class="d-flex flex-grow-1">
            <v-btn color="yellow" text @click="takebreak('short')">Short Break</v-btn>
            <v-btn color="orange" text @click="takebreak('long')">Long Break</v-btn>
            <v-btn color="red" text @click="takebreak('rest_of_day')">Take the day off</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="askTakeBreak=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askDontWantToLeave" width="800">
        <v-card>
          <v-card-title>
            <span>Confirm {{ activeChatAccountName }} <strong style="color: #FF8C00">DON'T</strong> want to Leave?</span>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="text-subtitle-1">
                Use this if the account can't leave right now even if a reason to leave was automatically detected.
              </v-col>

              <v-col cols="12" class="text-center">
                Choose how long not to leave. After this ends it'll be able to leave.
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="d-flex align-center justify-center">
                <v-radio-group v-model="dontWantToLeaveRadioGroup" row hide-details class="ma-0">
                  <v-radio
                    label="Minutes"
                    value="minutes"
                  ></v-radio>
                  <v-radio
                    label="Hands"
                    value="hands"
                  ></v-radio>
                </v-radio-group>

                <v-text-field
                  v-model.number="dontWantToLeaveHowLong" hide-details outlined type="number"
                  dense label="How long?" :suffix="dontWantToLeaveRadioGroup"></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea
                  v-model="dontWantToLeaveReason" outlined dense hide-details
                  label="Reason (required)"></v-textarea>
              </v-col>
            </v-row>

          </v-card-text>
          <v-card-actions class="d-flex flex-grow-1">
            <v-btn
              text @click="askDontWantToLeave=false; dontWantToLeave();" color="green"
              :disabled="!dontWantToLeaveHowLong || dontWantToLeaveReason.length < 3"
            >Submit</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="askDontWantToLeave=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askRemoveDontWantToLeave" width="600">
        <v-card>
          <v-card-title>Remove {{ activeChatAccountName }} DON'T want to Leave?</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                Use this if the account can leave again.
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex flex-grow-1">
            <v-btn color="red" text @click="removeDontWantToLeave">Confirm</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="askRemoveDontWantToLeave=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askWantToLeave" width="800">
        <v-card>
          <v-card-title>Confirm {{ activeChatAccountName }} Want to Leave?</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="text-subtitle-1">
                Use this if the account needs to leave for a reason that wasn't automatically detected.
              </v-col>

              <v-col cols="12" class="text-center">
                Choose a break option to make the account not try to sit again after leaving.
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex flex-grow-1">
            <v-btn color="yellow" text @click="wantToLeave('short')">Short Break</v-btn>
            <v-btn color="orange" text @click="wantToLeave('long')">Long Break</v-btn>
            <v-btn color="red" text @click="wantToLeave('rest_of_day')">Take the day off</v-btn>
            <v-btn text @click="wantToLeave('no_break')">Without Break</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="askWantToLeave=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="askRemoveWantToLeave" width="600">
        <v-card>
          <v-card-title>Remove {{ activeChatAccountName }} Want to Leave?</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                Use this if the account doesn't need to leave anymore.
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex flex-grow-1">
            <v-btn color="red" text @click="removeWantToLeave">Confirm</v-btn>
            <v-spacer></v-spacer>
            <v-btn text @click="askRemoveWantToLeave=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askResolveRejectedBuyin" width="500">
        <v-card>
          <v-card-title>
            Confirm buy-in rejected resolved?
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                This will mark the buy-in rejected situation as resolved.
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green" text @click="onResolveRejectBuyin">Confirm</v-btn>
            <v-btn text @click="askResolveRejectedBuyin=false;">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="askReport" width="500">
        <v-card>
          <v-card-title>
            <template v-if="askReport && !askContactHost">Report Incident - {{ activeChatAccountName }}</template>
            <template v-else-if="askContactHost && !askContactHostResolved">Ask to Contact Host? - {{ activeChatAccountName }}</template>
            <template v-else>Confirm contact host resolved?</template>
          </v-card-title>
          <v-card-text>
            <v-row>
              <template v-if="askReport && !askContactHost">
                <v-col cols="12">
                  <v-textarea
                    label="Note"
                    outlined
                    hide-details
                    v-model="incident.note"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-radio-group v-model="incident.action">
                    <v-radio label="Recommend name change" value="change"></v-radio>
                    <v-radio label="Recommend retire account" value="retire"></v-radio>
                    <v-radio label="Just reporting" value="reporting"></v-radio>
                    <v-radio color="red darken-3" value="issue">
                      <template v-slot:label>
                        <div><strong class="red darken-3">Technical Issue</strong></div>
                      </template>
                    </v-radio>
                  </v-radio-group>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="12">
                  <template v-if="askContactHostResolved">
                    This will mark the contact host situation as resolved.
                  </template>
                  <template v-else>
                    Confirming here will send a notification to the manager of the account to handle the contact with the host.
                  </template>
                </v-col>
              </template>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <template v-if="askReport && !askContactHost">
              <v-btn color="green" text @click="onReportIncident" :disabled="incident.note.length < 2">Confirm</v-btn>
            </template>
            <template v-else>
              <v-btn color="green" text @click="onReportContact">Confirm</v-btn>
            </template>
            <v-btn text @click="askReport=false; askContactHost=false; askContactHostResolved=false">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showContactHostDone" width="600">
        <v-card>
          <v-card-title>
            The account manager is already being contacted 👍
          </v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="showContactHostDone=false;">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import {
  getResult,
  getTime } from '@/plugins/helpers.js';
import { getDivider, getPlayer } from '../plugins/helpers';
import { displayIDFromKey } from '@/plugins/store_updates';

export default {
  data() {
    return {
      ctWindowInput: {
        start: 0, size: 5,
        get end() {
          return parseInt(this.start) + parseInt(this.size);
        },
      },
      chips: 0,
      sitChips: 0,
      bonusReason: "",

      warningQuantityInput: 0,

      askLeave: false,
      askSitOut: false,
      askRestart: false,
      safeRestart: true,
      askLogout: false,
      askWarning: false,
      askChangeWarningQuantity: false,
      askWarnAgain: false,
      askTakeBreak: false,

      askDontWantToLeave: false,
      askRemoveDontWantToLeave: false,

      askWantToLeave: false,
      askRemoveWantToLeave: false,
      dontWantToLeaveRadioGroup: 'hands',
      dontWantToLeaveReason: '',
      dontWantToLeaveHowLong: 10,

      askReload: false,
      askAddBonus: false,
      askRemoveWarning: false,
      askReport: false,
      askResolveRejectedBuyin: false,
      askSit: false,
      askLeaveOnly: false,
      askTimeOutHand: false,
      askTimeOutOnce: false,
      askGetUpOnly: false,
      askGetUpSafely: false,
      askContactHost: false,
      askContactHostResolved: false,
      showContactHostDone: false,

      showDebugAs: false,

      incident: {
        displayID: "",
        action: "reporting",
        note: ""
      },
    };
  },
  computed: {
    systemAskingToStand() {
      // new automation logic
      if (this.as && this.as.stand_now) {
        return true;
      }

      // nothing telling it to stand
      return false;
    },

    as() {
      let as = this.activeAutomationState;

      if (!as) {
        return null;
      }

      return as;
    },
    currentHandNum() {
      let st = this.state;
      if (st) {
        // state has hand_num on it
        return st.hand_num;
      }

      // fall-back on automation state
      if (this.as) {
        // we are on the hand after the last automation state
        return this.as.handSN + 1;
      }

      // we don't know
      return 0;
    },
    state() {
      return this.accountState(this.activeChatAccountName);
    },
    activeDisplayID() {
      return (this.activeChatAccount || {}).displayID || displayIDFromKey(this.activeChatAccountName);
    },
    activeRoomId() {
      if ((this.activeChatAccount || {}).roomId) return this.activeChatAccount.roomId;
      return this.state ? this.state.room_id : null;
    },
    activeSlot() {
      return (this.activeChatAccount || {}).slot || this.activeRoomId;
    },
    isTournament() {
      if (!this.state) return false;
      if (!("settings" in this.state)) return false;
      if (!this.state.settings) return false;
      return "prizePlan" in this.state.settings && (!this.state.settings.rummy);
    },
    weAreObserving() {
      let as = this.as;

      if (!as) {
        return false;
      }

      return as.we_are_observing;
    },
    isSitting() {
      let p = this.ourPlayer;

      if (!p) return false;

      if (p.seat === 0) return true;

      if (p.seat && p.seat >= 0) return true;

      return false;
    },
    ourStack() {
      let p = this.ourPlayer;
      // console.log(p);
      try {
        let s = this.state.settings;
        let d = 1;
        if (s.withDecimal) {
          d = 100;
        }
        return (p.stack / d).toFixed(2);
      } catch {
        // some error getting stack
      }
      return 0;
    },
    balance() {
      let aca = this.activeChatAccount;
      if (aca && aca.available_bankroll) {
        return aca.available_bankroll.toFixed(2);
      }
      return 0;
    },
    club() {
      return this.activeClubmgmClub || {};
    },
    onlyRequiredChats() {
      return !!(((this.activeClubmgmAccount || {}).funding_agent || {}).bots_only_required_chats);
    },
    isOurClubPartnerBot() {
      return this.club.is_our && (this.activeClubmgmAccount || {}).is_partner_bot;
    },
    isCalltimeClubWithoutWindow() {
      return this.club && this.club.warn_suggestion_type === 'ct_without_window';
    },
    calltimeText() {
      if (!this.club) return 'ct';
      let cText = this.club.warn_suggestion_text || 'ct';
      // first letter uppercase
      return cText.charAt(0).toUpperCase() + cText.slice(1);
    },
    isCalltimeClubWithWindow() {
      let isINR = this.activeClubmgmClub && this.activeClubmgmClub.currency === 'INR';
      let isCtWithWindow = this.club && this.club.warn_suggestion_type === 'ct_with_window';

      return isINR || isCtWithWindow;
    },
    ourPlayer() {
      return this.state_ourPlayer(this.activeChatAccountName);
    },
    isResolvedDisabled() {
      if (this.isDisconnected) {
        return true;
      }
      if (!this.activeChatAccount.contacting_host_users) return false;
      if (!(this.activeOperatorId in this.activeChatAccount.contacting_host_users)) return false;

      return this.activeChatAccount.contacting_host_users[this.activeOperatorId].action !== 'handling';
    },
    canResolveRejectedBuyin() {
      if (!this.activeChatAccount.buyin_state) return false;
      let buyinState = this.activeChatAccount.buyin_state;

      if (buyinState.type !== 'rejected') return false;
      if (buyinState.status === 'handled') return false;
      if (!buyinState.contacting_users) return false;

      if (!(this.activeOperatorId in buyinState.contacting_users)) return false;

      return buyinState.contacting_users[this.activeOperatorId].action === 'handling';
    },
    ...mapGetters([
      'activeChatAccount',
      'activeChatAccountName',
      'activeAutomationState',
      'activeClubmgmAccount',
      'activeClubmgmClub',
      'accountState',
      'result',
      'gameType',
      'opponents',
      'isDebug',
      'isClaud',
      'isDev',
      'isAdmin',
      'isManager',
      'activeOperatorId',
      'operatorUserName',
    ]),
    ...mapGetters({
      'state_ourPlayer': 'ourPlayer',
    }),
    ...mapState([
      'testPreview',
      'testWarnings',
      'playerActionsKey',
      'isDisconnected',
    ])
  },
  methods: {
    actionPayload(extra={}) {
      return {
        'displayID': this.activeDisplayID,
        'roomId': this.activeRoomId,
        'slot': this.activeSlot,
        ...extra,
      };
    },
    ruleName(rule) {
      let name = rule.type;
      if (name === "win_gte_bb") {
        return "If win " + rule.gte_bb + " BBs or more";
      } else if (name === "never") {
        return "Never";
      } else if (name === "win_gte_chm") {
        return "If win $" + rule.gte_chm + " or more";
      } else if (name === "re_double_up") {
        return "If Double-up Again";
      } else if (name === "re_triple_up") {
        return "If Triple-up Again";
      } else if (name === "custom") {
        return rule.custom;
      } else if (name === "when_winning") {
        return "When Winning";
      } else if (name === "always") {
        return "Always";
      } else if (name === "double_up") {
        return "If Double-up";
      } else if (name === "triple_up") {
        return "If Triple-up";
      } else if (name === "play_another_35") {
        return "If Play Another 35 Hands"
      }
      return name;
    },
    getBB(code) {
      if (!(code in this.opponents)) return 0;
      let gameType = this.gameType(this.activeChatAccountName).toLowerCase();

      if (gameType === "plo4") {
        gameType = "plo";
      } else if (gameType === "plo5") {
        gameType = "plo5c";
      } else if (gameType === "plo6") {
        gameType = "plo6c";
      }

      return this.opponents[code].bbs[gameType];
    },
    getOpponentCode(name) {
      let state = this.accountState;
      if (!state) return null;

      for (let k in state.players) {
        if (state.players[k].name === name) {
          return state.players[k].code;
        }
      }
      return null;
    },
    getHands(code) {
      if (!(code in this.opponents)) return "";
      let gameType = this.gameType(this.activeChatAccountName).toLowerCase();

      if (gameType === "plo4") {
        gameType = "plo";
      } else if (gameType === "plo5") {
        gameType = "plo5c";
      } else if (gameType === "plo6") {
        gameType = "plo6c";
      }

      let hands = this.opponents[code].hands[gameType];

      return hands;
    },
    updateSnoozed() {
      this.$socket.emit("toggle_snoozed", {'displayID': this.activeDisplayID, 'byUserId': this.activeOperatorId});
    },
    updatePriming() {
      this.$socket.emit("toggle_priming", {'displayID': this.activeDisplayID, 'byUserId': this.activeOperatorId});
    },
    updateClaimed() {
      this.$socket.emit("toggle_claimed", {'displayID': this.activeDisplayID, 'byUserId': this.activeOperatorId});
    },
    takebreak(breakType) {
      this.$socket.emit("takebreak", {
        'displayID': this.activeDisplayID,
        'breakType': breakType
      });
      this.askTakeBreak = false;

      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    wantToLeave(breakType) {
      this.askWantToLeave = false;
      this.$socket.emit("operator_want_to_leave", {
        'displayID': this.activeDisplayID,
        'roomId': this.activeRoomId,
        'slot': this.activeSlot,
        'wantToLeave': true,
        'breakType': breakType
      });

      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    dontWantToLeave() {
      this.askDontWantToLeave = false;
      this.$socket.emit("operator_dont_want_to_leave", {
        'displayID': this.activeDisplayID,
        'roomId': this.activeRoomId,
        'slot': this.activeSlot,
        'dontWantToLeave': true,
        'howLong': this.dontWantToLeaveHowLong,
        'howLongType': this.dontWantToLeaveRadioGroup,
        'reason': this.dontWantToLeaveReason,
      });

      // reset dont want to leave values
      this.dontWantToLeaveRadioGroup = 'hands',
      this.dontWantToLeaveReason = '',
      this.dontWantToLeaveHowLong = 10,

      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    removeDontWantToLeave() {
      this.askRemoveDontWantToLeave = false;
      this.$socket.emit("operator_dont_want_to_leave", this.actionPayload({'dontWantToLeave': false}));
      this.closeDialog();
    },
    removeWantToLeave() {
      this.askRemoveWantToLeave = false;
      this.$socket.emit("operator_want_to_leave", this.actionPayload({'wantToLeave': false}));
      this.closeDialog();
    },
    restart() {
      this.askRestart = false;
      if (this.safeRestart) {
        this.$socket.emit("restart_safely", {'displayID': this.activeDisplayID});
      } else {
        this.$socket.emit("restart", {'displayID': this.activeDisplayID});
      }
      this.closeDialog();
    },
    logout() {
      this.askLogout = false;
      this.$socket.emit("logout", {'displayID': this.activeDisplayID});
      this.closeDialog();
    },
    bb() {
      let d = 1;
      let st = this.state;
      if (!st || !st.settings) return 0;
      if (st.settings.withDecimal) {
        d = 100;
      }
      return (st.settings.bb / d).toFixed(2);
    },
    hasGivenWarning() {
      let aca = this.activeChatAccount;
      let w = aca && aca.gave_warning;
      if (!w) return false;
      return true;
    },
    warningTime() {
      let aca = this.activeChatAccount;
      let w = aca && aca.gave_warning;
      if (!w) return '';
      return getTime(w.ts);
    },
    warningHand() {
      let aca = this.activeChatAccount;
      let w = aca && aca.gave_warning;
      if (!w) return '';
      return w.hand_num;
    },
    warningStack() {
      let aca = this.activeChatAccount;
      let w = aca && aca.gave_warning;
      if (!w) return '';
      let v = '';
      if (w.stack) {
        v = 'stack:' + parseInt(w.stack) + ' ';
      }
      if (w.result) {
        v += 'result: ' + parseInt(w.result);
      }
      return v;
    },
    leave() {
      this.askLeave = false;

      let aca = this.activeChatAccount;
      if (aca && aca.snoozed) {
        this.$socket.emit("toggle_snoozed", {'displayID': this.activeDisplayID});
      }

      this._sendEvent("stand_up");
      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    leaveOnly() {
      this.askLeaveOnly = false;

      let aca = this.activeChatAccount;
      if (aca && aca.snoozed) {
        this.$socket.emit("toggle_snoozed", {'displayID': this.activeDisplayID});
      }

      this._sendEvent("leave_immediately");
      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },

    timeOutOnce() {
      this.askTimeOutOnce = false;

      this._sendEvent("time_out_once");

      this.closeDialog();
    },
    timeOutHand() {
      this.askTimeOutHand = false;

      this._sendEvent("time_out_hand");

      this.closeDialog();
    },

    getUp() {
      this.askGetUpOnly = false;

      let aca = this.activeChatAccount;
      if (aca && aca.snoozed) {
        this.$socket.emit("toggle_snoozed", {'displayID': this.activeDisplayID});
      }

      this._sendEvent("stand_up_only");
      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    getUpSafely() {
      this.askGetUpSafely = false;

      let aca = this.activeChatAccount;
      if (aca && aca.snoozed) {
        this.$socket.emit("toggle_snoozed", {'displayID': this.activeDisplayID});
      }

      this._sendEvent("stand_up_safely");
      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },

    sitout() {
      this.askSitOut = false;
      this._sendEvent("sitout");
      this.closeDialog();
    },
    sitback() {
      this._sendEvent("sitback");
    },
    onSit() {
      this.askSit = false;
      this.closeDialog();

      // only stop showing if it succeeded
      let settings = this.state.settings;
      if (!this.sitChips) {
        return;
      }
      let chips = Math.round(parseFloat(this.sitChips) * 100)/100;
      if (!settings) {
        return;
      }
      if (settings.withDecimal) {
        chips *= 100;
      }
      // after withDecimal, we should always have an int amount
      chips = Math.round(chips);

      if (chips <= 0) return;
      chips = parseInt(chips);

      let st = this.state;

      if (!st || !st.room_id) {
        console.log("no room id for sit", this.state);
        return;
      }

      this.$socket.emit(
          'sit',
          {
            'displayID': this.activeDisplayID,
            'slot': this.activeSlot,
            'roomId': st.room_id,
            'buyinChips': chips,
          }
      );

      this.sitChips = 0;
    },
    onGaveWarning() {
      this.askWarning = false;

      let st = this.state;
      let hn = st.hand_num;
      let room_id = st.room_id;
      let result = getResult(st);
      let p = getPlayer(st);
      let d = getDivider(st);

      // NOTE: if this changes you must also change actions.py mark_gave_warning, they share the same
      // data structure
      let gave_warning = {
        'hand_num': hn,
        'room_id': room_id,
        'result': result,
        'stack': p.stack / d,
      };
      if (this.isCalltimeClubWithWindow) {
        // mark call-time window
        gave_warning.calltime = true;
        gave_warning.ct_window = {
          'start_hn': parseInt(this.ctWindowInput.start),
          'end_hn': parseInt(this.ctWindowInput.end),
        };
      }
      this.$socket.emit("gave_warning", {
        'displayID': this.activeDisplayID,
        'roomId': room_id,
        'slot': this.activeSlot,
        'gave_warning': gave_warning,
      });
      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    onRemoveGaveWarning() {
      this.askRemoveWarning = false;

      this.$socket.emit("remove_warning", {
        'displayID': this.activeDisplayID,
        'roomId': this.activeRoomId,
        'slot': this.activeSlot,
      });
      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    onWarnedAgain() {
      this.askWarnAgain = false;

      let st = this.state;
      let hn = st.hand_num;
      let room_id = st.room_id;
      let result = getResult(st);
      let p = getPlayer(st);
      let d = getDivider(st);
      this.$socket.emit("warned_again", {
        'displayID': this.activeDisplayID,
        'roomId': room_id,
        'slot': this.activeSlot,
        'warned_again': {
          'hand_num': hn,
          'room_id': room_id,
          'result': result,
          'stack': p.stack / d,
        }
      });
      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    },
    observe30mins() {
      this.$socket.emit("keep_observing_table", {
        'displayID': this.activeDisplayID,
        'roomId': this.activeRoomId,
        'slot': this.activeSlot,
        'seconds': 1800,
      });
    },
    reloadCustom(isBonus=false) {
      this.askReload = false;
      this.askAddBonus = false;

      let chips = parseFloat(this.chips);
      let bonusReason = this.bonusReason;
      // console.log(chips);
      if (chips <= 0) return;
      let st = this.state;
      if (!st) return;
      let settings = st.settings;
      if (!settings) {
        settings = st.room.settings;
      }
      if (!settings) {
        return;
      }
      if (settings.withDecimal) {
        chips = Math.round(chips * 100);
      }
      // console.log("final custom chips:", chips);
      this.chips = 0;
      this.bonusReason = "";
      this.sendReload(chips, st.room_id, isBonus, bonusReason, settings.withDecimal);
    },
    reload() {
      let st = this.state;
      this.askReload = false;
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }
      let settings = st.settings;
      if (!settings) {
        settings = st.room.settings;
      }
      if (!settings) {
        return;
      }
      let bb = settings.bb;
      let chips = chips = 100 * bb;
      this.sendReload(chips, st.room_id, false, "not a bonus", settings.withDecimal);
    },
    sendReload(chips, room_id, isBonus=false, reason="", withDecimal=false) {
      this.$socket.emit(
        'reload',
        {
          'displayID': this.activeDisplayID,
          'slot': this.activeSlot,
          'roomId': room_id,
          'chips': chips,
          'isBonus': isBonus,
          'bonusReason': reason,
          'withDecimal': withDecimal
        }
      );
    },
    _sendEvent(evt) {
      let name = this.activeDisplayID;
      if (!this.$socket) return;
      let st = this.state;
      if (!st || !st.room_id) {
        console.log("no room id");
        return;
      }
      console.log("sending event", evt, name);
      this.$socket.emit(evt, {'displayID': name, 'roomId': st.room_id, 'slot': this.activeSlot})

    },
    precomputeCalltimeWindow() {
      let hn = this.currentHandNum;

      if (hn) {
        // usually it starts 30 after we give call-time
        this.ctWindowInput.start = hn + 30;
        // and size is 5
        this.ctWindowInput.size = 5;
        return;
      }

      // clear it
      this.ctWindowInput.start = 0;
      this.ctWindowInput.size = 5;
    },
    openDialog() {
      this.$store.commit("autoFocus", false);

      try {
        this.precomputeCalltimeWindow();
      } catch {
        console.exception("failed compute calltime");
      }
    },
    closeDialog() {
      this.$store.commit("autoFocus", true);
    },

    openPopup() {
      window.open(
          `/questions?accountId=${(this.activeClubmgmAccount||{})._id}`,
          "",
          "width=400,height=600,left=200,top=200"
      );
    },

    openTable() {
      window.open(
          `/table?accountName=${this.activeDisplayID}${this.activeSlot ? `&slot=${this.activeSlot}` : ''}`,
          "",
          "width=420,height=680,left=200,top=200"
      );
    },

    openResolveRejectedBuyin() {
      this.askResolveRejectedBuyin = true;
    },

    openReport(isContact=false, isResolved=false) {
      this.askReport = true;

      if (isContact) {
        this.askContactHost = true;
      } else {
        this.askContactHost = false;
      }

      if (isContact && isResolved) {
        this.askContactHostResolved = true;
      }

      this.incident = {
        displayID: this.activeDisplayID,
        roomId: this.activeRoomId,
        slot: this.activeSlot,
        action: isContact ? "contact" : "reporting",
        note: ""
      }
    },

    onResolveRejectBuyin() {
      this.askResolveRejectedBuyin = false;
      this.$socket.emit("buyin_rejected_resolved", this.actionPayload());
    },

    onReportContact() {

      if (this.askContactHostResolved) {
        this.$socket.emit("contact_host_resolved", this.actionPayload());
      } else {
        this.$socket.emit("contact_host", this.actionPayload());

        this.showContactHostDone = true;
      }

      this.askReport = false;
      this.askContactHost = false;
      this.askContactHostResolved = false;
    },

    onReportIncident() {
      this.askReport = false;
      this.askContactHost = false;
      this.askContactHostResolved = false;

      this.$axios.post("/api/reporting", this.incident).then(() => {
        console.log("reported");
      }).catch((err) => {
        console.error(err);
      })
    },

    openDebugAs() {
      this.showDebugAs = true;
    },

    getChangeWarningQuantityType() {
      if (!this.club) return null;
      if (!this.club.initial_warning_rule) return null;
      let rule = this.club.initial_warning_rule;

      return rule.warning_quantity_type;
    },

    getWarningQuantityValue() {
      if (!this.club) return null;
      if (!this.club.initial_warning_rule) return null;
      let rule = this.club.initial_warning_rule;
      let quantityType = this.getChangeWarningQuantityType();

      // override with already set warning quantity
      let aca = this.activeChatAccount;
      if (aca && aca.gave_warning && aca.gave_warning.warning_quantity) {
        return aca.gave_warning.warning_quantity;
      }

      return quantityType === 'minutes' ? rule.num_minutes : rule.num_hands;
    },

    changeWarningQuantity() {
      this.askChangeWarningQuantity = false;
      this.$socket.emit("change_warning_quantity", {
        'displayID': this.activeDisplayID,
        'roomId': this.activeRoomId,
        'slot': this.activeSlot,
        'quantity': this.warningQuantityInput,
      });

      this.$store.commit("invalidateAccountCache");
      this.closeDialog();
    }
  }
}
</script>

<style scoped>
@keyframes anim {
  0%   {color: white;}
  50%  {color: #d73c3c;}
  100% {color: white;}
}

.player-actions2 {
  height: 100% !important;
  min-height: 200px;
  margin: 0;
}

.player-actions2 > div {
  padding: 0;
}

.warn-stand-now {
  color: red;
}

.warn-warn-now {
  color: cornflowerblue;
}

</style>
